import { apiTelegramBotInfo } from '@/resource/telegram'
import { isSuccess } from '@/util/utils'

export default {
  async getTelegramBotInfo({ commit, state }) {
    const result = await apiTelegramBotInfo()

    if (isSuccess(result.data) && result.data.data) {
      commit('setTelegramBotInfo', {
        bot_id: result.data.data.botId,
        telegram_login: result.data.data.userName,
      })
    }
  },
}
